module.exports = __webpack_public_path__ + "static/media/masons.01fc839f.png";